import { MapTo } from "@adobe/aem-react-editable-components";
import { AuthoringUtils } from "@adobe/aem-spa-page-model-manager";
import { PointsHistory } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const pointsHistoryEditConfig = {
    emptyLabel: "PointsHistory",
    isEmpty: (props) => !props.title ||
        !props.dateLabel ||
        !props.eventLabel ||
        !props.balanceLabel ||
        !props.defaultPointsAddedMessage ||
        !props.pointsOrderAddedMessage ||
        !props.pointsRedemptionMessage ||
        !props.pointsCouponRedemptionMessage ||
        !props.pointsCancellationMessage ||
        !props.pointsExpirationMessage,
    getProps: (props) => ({
        isFullPointsHistory: props.isFullPointsHistory,
        url: props.url,
        text: props.text,
        title: props.title,
        loadAmount: props.loadAmount,
        defaultPointsAddedMessage: props.defaultPointsAddedMessage,
        defaultPointsSpentMessage: props.defaultPointsSpentMessage,
        pointsRedemptionMessage: props.pointsRedemptionMessage,
        pointsCouponRedemptionMessage: props.pointsCouponRedemptionMessage,
        pointsRefundMessage: props.pointsRefundMessage,
        pointsOrderAddedMessage: props.pointsOrderAddedMessage,
        pointsCancellationMessage: props.pointsCancellationMessage,
        pointsExpirationMessage: props.pointsExpirationMessage,
        externalCouponLinkLabel: props.externalCouponLinkLabel,
        dateLabel: props.dateLabel,
        eventLabel: props.eventLabel,
        pointsLabel: props.pointsLabel,
        balanceLabel: props.balanceLabel,
        isInEditor: AuthoringUtils.isInEditor(),
    }),
};
export default MapTo("loyalty/components/pointshistory")(withAemAuthoring(PointsHistory, pointsHistoryEditConfig));
